import SkillNotification from "../components/Skills/SkillNotification";
import { getStoreValue, stores } from "../utils/store";
import { keyBy } from "../utils/utils";
import { getSkillsRequest } from "./endpoints/skill";
import { openNotification } from "./notification";
import { TaskProps } from "./task";

export enum SkillTypes {
    BODY, HEALTH, MIND, KNOWLEDGE, PROGRAMMING, ENGINEERING, MUSIC, ART, COOKING, ENVIRONMENT, FINANCES, SOCIAL
}

export interface SkillProps {
    id: SkillTypes,
    name: string,
    icon: string,
    xpTotal: number,
}

export const Skills: SkillProps[] = [
    { id: SkillTypes.BODY, name: 'Body', icon: 'body', xpTotal: 0 },
    { id: SkillTypes.HEALTH, name: 'Health', icon: 'health-2', xpTotal: 0 },
    { id: SkillTypes.MIND, name: 'Mind', icon: 'mind', xpTotal: 0 },
    { id: SkillTypes.KNOWLEDGE, name: 'Knowledge', icon: 'knowledge', xpTotal: 0 },
    { id: SkillTypes.PROGRAMMING, name: 'Programming', icon: 'programming', xpTotal: 0 },
    { id: SkillTypes.ENGINEERING, name: 'Engineering', icon: 'engineering', xpTotal: 0 },
    { id: SkillTypes.MUSIC, name: 'Music', icon: 'music', xpTotal: 0 },
    { id: SkillTypes.ART, name: 'Art', icon: 'drawing4', xpTotal: 0 },
    { id: SkillTypes.COOKING, name: 'Cooking', icon: 'cooking-6', xpTotal: 0 },
    { id: SkillTypes.ENVIRONMENT, name: 'Environment', icon: 'environment-5', xpTotal: 0 },
    { id: SkillTypes.FINANCES, name: 'Finances', icon: 'finances-3', xpTotal: 0 },
    { id: SkillTypes.SOCIAL, name: 'Social', icon: 'social-1', xpTotal: 0 },
];

export function getSkillLevel(xp: number): number {
    if (xp < 10) return 0;
    const currentLevel = Math.log((xp + 10) / 10) / Math.log(2);
    return Math.floor(currentLevel);
}

export function getSkillLevelRequiredXp(level: number): number {
    if (level <= 0) return 0;
    return 10 * 2 ** (level) - 10;
}

// export const SkillsByName: { [name: Skill['name']]: Skill } = Skills.reduce((skillsByName, skill) => { skillsByName[skill.name] = skill; return skillsByName }, {} as { [name: Skill['name']]: Skill })
export const SkillsByName = keyBy(Skills, 'id');

let loadPromise: Promise<boolean>;

export function loadSkills(): Promise<boolean> {
    if (!loadPromise) loadPromise = getSkillsRequest().then((skills) => stores.skills.set(skills)).then();
    return loadPromise;
}

export function handleSkillRewards(reawards: TaskProps['rewards']) {
    if (!reawards || !reawards.length) return;
    // loadSkills().then(() => )
    const skillsCopy = [...getStoreValue(stores.skills)];
    const skillsByName = keyBy(skillsCopy, 'id')

    reawards.forEach((reward) => {
        skillsByName[reward.type].xpTotal += reward.xp;
        openNotification({ body: <SkillNotification reward={reward}></SkillNotification>, duration: 1500 + reward.xp * 1000 });
    })

    stores.skills.set(skillsCopy);
    localStorage.setItem('skills', JSON.stringify(skillsCopy));
}